import { z } from "zod";

const PortalStatusSchema = z.enum(["draft", "published"]);

export const PortalCreatedActionSchema = z.object({
  action: z.literal("portalCreated"),
  portalId: z.string().uuid(),
  portalName: z.string(),
  editUrl: z.string(),
});

export const PortalUpdatedActionSchema = z.object({
  action: z.literal("portalUpdated"),
  portalId: z.string().uuid(),
  html: z.string().nullable(),
  jsonTree: z.unknown().nullable(),
});

export const PortalPublishedActionSchema = z.object({
  action: z.literal("portalPublished"),
  portalId: z.string().uuid(),
  portalUrl: z.string(),
});

const PortalListItemSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  status: PortalStatusSchema,
  customerId: z.string().uuid(),
  createdAt: z.coerce.date(),
});

export const PortalListActionSchema = z.object({
  action: z.literal("portalList"),
  portals: z.array(PortalListItemSchema),
});

export const PortalAgentActionSchema = z.discriminatedUnion("action", [
  PortalCreatedActionSchema,
  PortalUpdatedActionSchema,
  PortalPublishedActionSchema,
  PortalListActionSchema,
]);

export type PortalCreatedAction = z.infer<typeof PortalCreatedActionSchema>;
export type PortalUpdatedAction = z.infer<typeof PortalUpdatedActionSchema>;
export type PortalPublishedAction = z.infer<typeof PortalPublishedActionSchema>;
export type PortalListAction = z.infer<typeof PortalListActionSchema>;
export type PortalAgentAction = z.infer<typeof PortalAgentActionSchema>;
